import { useState, useEffect } from "react";
import { ZoomEventTarget } from "./helpers";

export const UI = (props) => {
  const [zoomEnded, setZoomEnded] = useState([
    { isFullRoom: false, meshName: "" },
  ]);

  useEffect(() => {
    ZoomEventTarget.addEventListener("zoomEnded", (e) => {
      setZoomEnded({ fullRoom: e.isFullRoom, meshName: e.meshName });
    });
  }, []);

  if (!zoomEnded.meshName) return null;

  // return (
  //   <div
  //     style={{
  //       textAlign: "center",
  //       position: "fixed",
  //       top: 0,
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       width: "inherit",
  // zIndex:999
  //     }}
  //   >
  //     <p>Zoom loppui {zoomEnded.meshName}</p>
  //   </div>
  // );
};
